import React, { Fragment, useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Divider,
  InputNumber,
  Switch,
  Select,
} from 'antd';
import { Timestamp } from 'firebase/firestore';
import { StoreContext } from '../store/index';
import { fetchShiftById } from './api';
import Shift from './shift';
import { onCollectionChange } from '../utils';

function ViewShiftModal({ shift, setShift, onClose }) {
  const store = useContext(StoreContext);
  const { id } = shift;
  const {
    user: [user],
    sports: [sports],
  } = store;

  const [shiftsChanged, setShiftsChanged] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    onCollectionChange('shifts', setShiftsChanged);
  }, []);

  useEffect(() => {
    fetchShiftById(id, setLoading).then(data => {
      if (data?.length > 0) {
        setShift(data[0]);
      }
    });
  }, [shiftsChanged]);

  return (
    <Modal title={`Partido ${id}`} visible onCancel={onClose} footer={null} width="100%">
     <Shift shift={shift} />
    </Modal>
  );
}

export default ViewShiftModal;
